<template>
  <div class="landing-layout">
    <LandingStickyHeader
      :handle-c-t-a-button-click="handleCTAButtonClick"
      :show-sticky-header="showStickyHeader"
    />
    <StartJourneyCOPD
      :cta-btn-title="
        $t('b2b__landing_page__generic__cta_btn__claim_my_benefit')
      "
      :handle-c-t-a-button-click="handleCTAButtonClick"
      :receive-c-t-a-button-client-rect="receiveCTAButtonClientRect"
    />
    <ValueProposition />
    <ProgramOverview
      :cta-btn-title="$t('b2b__landing_page__generic__cta_btn__title')"
      :handle-c-t-a-button-click="handleCTAButtonClick"
      background-color-class="kds-color-background-green-subtle"
    />
    <RealMembers />
    <Landing3Steps
      :cta-btn-title="$t('b2b__landing_page__generic__cta_btn__title')"
      :handle-c-t-a-button-click="handleCTAButtonClick"
    />
    <FaqModule />
    <Contacts />
    <FooterLanguage />
    <FooterCertificates />
    <FooterLinks />
  </div>
</template>

<script setup>
import { generateSignupContext, setPageTitle } from '@shared/utils'
import { computed, ref, watch } from 'vue'
import ROUTE from '@us/app/router/appModule/names'
import Contacts from '@us/app/components/Contacts.vue'
import FaqModule from '@shared/components/FaqModule.vue'
import Landing3Steps from '@shared/components/Landing3Steps.vue'
import LandingStickyHeader from '@shared/components/LandingStickyHeader.vue'
import RealMembers from '@shared/components/RealMembers.vue'
import { useI18n } from 'petite-vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import ValueProposition from '@shared/components/ValueProposition.vue'
import StartJourneyCOPD from '@us/app/components/StartJourneyCOPD.vue'
import ProgramOverview from '@shared/components/ProgramOverview.vue'
import FooterCertificates from '@us/app/components/FooterCertificates.vue'
import FooterLinks from '@us/app/components/FooterLinks.vue'
import FooterLanguage from '@us/app/components/FooterLanguage.vue'
import useUsStore from '@us/app/stores/useUsStore.js'
import useLandingPageStore from '@shared/stores/useLandingPageStore.js'

const { t } = useI18n()
const usStore = useUsStore()
const landingPageStore = useLandingPageStore()
const router = useRouter()
const currentRoute = useRoute()

const landingPage = computed(() => landingPageStore.landingPage)
const displayTitle = computed(() => landingPage.value?.displayTitle || '')
const getCTAButtonClientRect = ref(() => {})

const showStickyHeader = () => {
  const rect = getCTAButtonClientRect.value()
  return rect != null && rect.top <= -rect.height / 2
}

const receiveCTAButtonClientRect = (clientRect) => {
  getCTAButtonClientRect.value = clientRect
}

const handleCTAButtonClick = () => {
  usStore.updateSignupContext(generateSignupContext())

  const resolvedRoute = router.resolve({
    name: ROUTE.SELECT_VERIFICATION_METHOD,
    params: { slug: landingPage.value?.slug },
    query: currentRoute.query,
  })
  window.open(resolvedRoute.href, '_blank', 'noopener')
}

watch(
  displayTitle,
  (title) => {
    setPageTitle(
      [
        title ? `${title} | ` : '',
        t('b2b__landing_page__generic__page_title'),
      ].join(''),
    )
  },
  { immediate: true },
)
</script>

<style lang="scss">
.landing-layout {
  width: 100%;
  min-width: 320px;
  margin: 0 auto;
}
</style>
